import { Link, useLoaderData, useOutletContext, useParams } from "react-router";

import { LockIcon } from "lucide-react";

import { Button } from "@/components/ui/button";

import { Project } from "@/features/projects/types";
import EditTicketForm from "@/features/tickets/components/EditTicketForm";
import { Ticket } from "@/features/tickets/types/index";
import { EmptyState } from "@/shared/components/EmptyState";
import { PERMISSIONS } from "@/shared/lib/constants/permissions";

export default function EditTicket() {
  const { id } = useParams();
  const { ticket } = useLoaderData() as { ticket: Ticket };
  const { permissions } = useOutletContext<{ project: Project; permissions: string[] }>();

  if (!permissions.includes(PERMISSIONS.PROJECT_TICKETS_UPDATE)) {
    return (
      <EmptyState
        icon={LockIcon}
        title="No access"
        description="You don't have permission to edit tickets in this project. Contact an administrator to request access."
        action={
          <Button asChild variant="outline" size="sm">
            <Link to={`/projects/${id}/tickets`}>Back to tickets</Link>
          </Button>
        }
      />
    );
  }

  return <EditTicketForm ticket={ticket} />;
}
